import React from 'react'
import classes from "../Projects/Projects.module.css"
import imga from "../Projects/shares.jpg"
import img2 from "../Projects/img.jpg"
import img3 from "../Projects/shape.png"
import { Carousel } from "react-bootstrap";
function Projects() {
  return (
  <div className={classes.main}>
      <h2>Projects</h2>
      




  <div className={classes.flow}>

        

    <div className={classes.card}>
      <div className={classes.imgs}>
      <img src={imga} />
      </div>
      <div className={classes.cont}>
        <div className={classes.title}>File Pioneer</div>
        <div className={classes.desc}>
File sharing Projects in which a file can be shared with alll the devices when thaat are connected to a network like wifi and can access all teh file what user have uploaded and also file coversion can be possible.

            </div>
            
        <div className={classes.Link}>
          <a href='https://drive.google.com/file/d/1u2fM4vucfMp41uPn5nq0Z9CqhWJ0rMbs/view?usp=share_link' target="_blank">Click Here</a>
        </div>
      </div>
    </div>

    <div className={classes.card}>
      <div className={classes.imgs}>
       <img src={img2} />
      </div>
      <div className={classes.cont}>
        <div className={classes.title}>Online Mail Verification</div>
        <div className={classes.desc}>
          This project is the simple functionality of the forget password in which we receive the verificaion mail from the root and with a code later that will get entered into the form to get or update to new password.
        </div>
        <div className={classes.Link}>
          <a href="#" target="_blank">Click Here</a>
        </div>
      </div>
    </div>  

    <div className={classes.card}>
      <div className={classes.imgs}>
        <img src={img3} width="99%"/>
      </div>
      <div className={classes.cont}>
        <div className={classes.title}>Image Shape Prediction and Detection</div>
        <div className={classes.desc}>This project focus on the object detection and prediction of the it,it also find its dimesions sunch as length and width and after processing it,the utput displayed and put it in audioformat.</div>
        <div className={classes.Link}>
        <a href="#" target="_blank" >Click Here</a>
        </div>
      </div>
        </div>

        
      </div> 
  
  </div>)
}

export default Projects;